// For Mobile Number Format
export function isCorrectMobileNumberFormat(value) {
  return value.length > 10;
}

// Has Correct Format Type Password
export function isCorrectPasswordFormat(value) {
  return value.length > 7;
}

// Has reached max characters (250)
export function hasReached250Characters(value) {
  return value.length < 251;
}

export function alphaSpace(value) {
  var regex = /^[a-zA-Z ]*$/
  return regex.test(value)
}


// WEBPACK FOOTER //
// ./src/form-validators.js